import { PAGE_TYPE } from "enums";
import { getLanguageValue } from "locales/i18n";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const Menu = () => {
    const pathname = useLocation().pathname;

    const getIconSrc = (path: string, icon: string) => {
        return path === '/school'
            ? pathname === path ? `./imgs/icons/${icon}-active.svg` : `./imgs/icons/${icon}.svg`
            : pathname.startsWith(path) ? `./imgs/icons/${icon}-active.svg` : `./imgs/icons/${icon}.svg`;
    };


    return (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center pb-2">
            {/* 메인 메뉴 */}
            <div className={`bg-white/80 backdrop-blur-md rounded-2xl shadow-sm px-1 py-1 transition-all duration-300 ${pathname != '/school' ? 'opacity-0 translate-y-full invisible' : 'opacity-100 translate-y-0 visible'}`}>
                <div className="flex gap-2 sm:gap-4 md:gap-6">
                    {/* 홈 */}
                    <Link to="/school" className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                            <img src={getIconSrc('/school', 'icon-home')} alt={getLanguageValue(PAGE_TYPE.SCHOOL, "mainMenu.txtHome")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] sm:text-xs font-medium ${pathname === '/school' ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                {getLanguageValue(PAGE_TYPE.SCHOOL, "mainMenu.txtHome")}
                            </p>
                        </div>
                    </Link>

                    {/* 원생 */}
                    <Link to="/school/student" className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                            <img src={getIconSrc('/school/student', 'icon-profile')} alt={getLanguageValue(PAGE_TYPE.SCHOOL, "mainMenu.txtStudent")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] sm:text-xs font-medium ${pathname.startsWith('/school/student') ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                {getLanguageValue(PAGE_TYPE.SCHOOL, "mainMenu.txtStudent")}
                            </p>
                        </div>
                    </Link>

                    {/* 캐스팅 */}
                    <Link to="/school/casting" className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                            <img src={getIconSrc('/school/casting', 'icon-casting')} alt={getLanguageValue(PAGE_TYPE.SCHOOL, "mainMenu.txtCasting")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] sm:text-xs font-medium ${pathname.startsWith('/school/casting') ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                {getLanguageValue(PAGE_TYPE.SCHOOL, "mainMenu.txtCasting")}
                            </p>
                        </div>
                    </Link>
                </div>
            </div>

            {/* 원생 메뉴 */}
            <div className={`absolute pb-2 bottom-0 left-0 right-0 flex justify-center transition-all duration-300 ${pathname.startsWith('/school/student') ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-full invisible'}`}>
                <div className="bg-white/80 backdrop-blur-md rounded-2xl shadow-sm px-1 py-1">
                    <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-center">
                        <Link to="/school" className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                                <img src="./imgs/icons/icon-arrow-left-1.svg" alt="이전" className="w-4 h-4 sm:w-5 sm:h-5 mx-auto" />
                            </div>
                        </Link>
                        <div className="hidden sm:block h-5 w-[1px] bg-gray-200"></div>

                        <Link to="/school/student" className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                                <p className={`text-xs sm:text-sm font-medium ${pathname === '/school/student' ? 'text-[#CF3688]' : 'text-gray-700'} text-center whitespace-nowrap`}>
                                    {getLanguageValue(PAGE_TYPE.SCHOOL, "studentMenu.txtSummary")}
                                </p>
                            </div>
                        </Link>
                        <Link to="/school/student/list" className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                                <p className={`text-xs sm:text-sm font-medium ${pathname === '/school/student/list' ? 'text-[#CF3688]' : 'text-gray-700'} text-center whitespace-nowrap`}>
                                    {getLanguageValue(PAGE_TYPE.SCHOOL, "studentMenu.txtStudentList")}
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

            {/* 캐스팅 메뉴 */}
            <div className={`absolute pb-2 bottom-0 left-0 right-0 flex justify-center transition-all duration-300 ${pathname.startsWith('/school/casting') ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-full invisible'}`}>
                <div className="bg-white/80 backdrop-blur-md rounded-2xl shadow-sm px-1 py-1">
                    <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-center">
                        <Link to="/school" className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                                <img src="./imgs/icons/icon-arrow-left-1.svg" alt="이전" className="w-4 h-4 sm:w-5 sm:h-5 mx-auto" />
                            </div>
                        </Link>
                        <div className="hidden sm:block h-5 w-[1px] bg-gray-200"></div>

                        <Link to="/school/casting" className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                                <p className={`text-xs sm:text-sm font-medium ${pathname === '/school/casting' ? 'text-[#CF3688]' : 'text-gray-700'} text-center whitespace-nowrap`}>
                                    {getLanguageValue(PAGE_TYPE.SCHOOL, "castingMenu.txtSummary")}
                                </p>
                            </div>
                        </Link>

                        <Link to="/school/casting/message" className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                                <p className={`text-xs sm:text-sm font-medium ${pathname === '/school/casting/message' ? 'text-[#CF3688]' : 'text-gray-700'} text-center whitespace-nowrap`}>
                                    {getLanguageValue(PAGE_TYPE.SCHOOL, "castingMenu.txtMessage")}
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Menu;